module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "text-center"
  }, [_c('hr'), _vm._v("\n  © "), _c('a', {
    attrs: {
      "href": "//github.com/xudafeng"
    }
  }, [_vm._v("xdf")]), _vm._v(" " + _vm._s(new Date().getFullYear()) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9932b492"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./homepage/footer.vue
// module id = 38
// module chunks = 0